export default __webpack_public_path__ + "static/media/Withdraw.13b337d6.svg";